import { Button, Col, Divider, Drawer, Row, Tooltip, Upload } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import axios from "axios";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
// import ImgCrop from "antd-img-crop";
import EditCredentials from "./EditCredentials";
import EditPersonal from "./EditPersonal";
import EditBusiness from "./EditBusiness";
import EditContact from "./EditContact";
import CoverLogo from "./../../../assets/tinyimg/900x300logo.webp";
import LogoImg from "./../../../assets/tinyimg/logo.webp";
import ImgCrop from "antd-img-crop";
import { MapContainer, TileLayer } from "react-leaflet";
import EditLocation from "./EditLocation";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const PasswordItem = () => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">Password:</p>
    &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
  </div>
);

const AccountDetails = ({ open, close }) => {
  const { userData, handleRerunUser } = useContext(UserInfo);
  const [merchantInfo, setMerchantInfo] = useState({
    data: [],
    ready: false,
  });
  const [editPersonal, setEditPersonal] = useState(false);
  const [editBusiness, setEditBusiness] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [editCredentials, setEditCredentials] = useState(false);
  const [editLocation, setEditLocation] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const getMyMerchantInfo = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/my-merchant-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMyMerchantInfo();
  }, [getMyMerchantInfo]);

  const handleUploadLogo = ({ file }) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("file", file);
    axios
      .post("user/merchant/upload-logo", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Uploaded logo successfully.");
          setTimeout(() => {
            getMyMerchantInfo();
            handleRerunUser();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const handleUploadCover = ({ file }) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("file", file);
    axios
      .post("user/merchant/upload-cover", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Uploaded cover successfully.");
          setTimeout(() => {
            getMyMerchantInfo();
            handleRerunUser();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const props = {
    listType: "picture-card",
  };

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                close();
              }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      {merchantInfo.ready && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="site-description-item-profile-p">Cover</p>
          </div>
          <Row>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <Upload
                    fileList={[
                      {
                        uid: "1",
                        name:
                          merchantInfo.data[0].business_cover !== null
                            ? merchantInfo.data[0].business_cover
                            : "default-cover.png",
                        status: "done",
                        url:
                          merchantInfo.data[0].business_cover !== null
                            ? `${import.meta.env.VITE_API_IMAGE}cover/${
                                merchantInfo.data[0].business_cover
                              }`
                            : CoverLogo,
                      },
                    ]}
                    multiple={false}
                    listType="picture-card"
                    maxCount={1}
                    showUploadList={{
                      showRemoveIcon: false,
                    }}
                    customRequest={handleUploadCover}
                  >
                    Upload
                  </Upload>
                </div>
              </div>
            </Col>
          </Row>

          <Divider />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="site-description-item-profile-p">Logo</p>
          </div>
          <Row>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <ImgCrop rotationSlider>
                    <Upload
                      {...props}
                      fileList={[
                        {
                          uid: "1",
                          name:
                            merchantInfo.data[0].business_logo !== null
                              ? merchantInfo.data[0].business_logo
                              : "default-logo.png",
                          status: "done",
                          url:
                            merchantInfo.data[0].business_logo !== null
                              ? `${import.meta.env.VITE_API_IMAGE}logo/${
                                  merchantInfo.data[0].business_logo
                                }`
                              : LogoImg,
                        },
                      ]}
                      showUploadList={{
                        showRemoveIcon: false,
                      }}
                      customRequest={handleUploadLogo}
                    >
                      Upload
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </Col>
          </Row>

          <Divider />

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Personal</p>
            </div>
            <div>
              <Tooltip title="Edit Personal">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    // setSelectedData(text);
                    setEditPersonal(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Full Name"
                content={
                  <span style={{ fontWeight: "bold" }}>
                    {`${
                      merchantInfo.data[0].reg_firstname !== null
                        ? merchantInfo.data[0].reg_firstname
                        : ""
                    } ${
                      merchantInfo.data[0].reg_lastname !== null
                        ? merchantInfo.data[0].reg_lastname
                        : ""
                    }`}
                  </span>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Address"
                content={
                  <span style={{ fontWeight: "bold" }}>
                    {`${
                      merchantInfo.data[0].reg_street !== null
                        ? `${merchantInfo.data[0].reg_street.toUpperCase()}, `
                        : ""
                    } ${
                      merchantInfo.data[0].reg_barangay !== null
                        ? `${merchantInfo.data[0].reg_barangay.toUpperCase()}, `
                        : ""
                    } ${
                      merchantInfo.data[0].reg_city !== null
                        ? `${merchantInfo.data[0].reg_city.toUpperCase()}, `
                        : ""
                    } ${
                      merchantInfo.data[0].reg_province !== null
                        ? merchantInfo.data[0].reg_province.toUpperCase()
                        : ""
                    }`}
                  </span>
                }
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Business</p>
            </div>
            <div>
              <Tooltip title="Edit Business">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditBusiness(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Name"
                content={`${
                  merchantInfo.data[0].business_name !== null
                    ? merchantInfo.data[0].business_name
                    : ""
                }`}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Address"
                content={`${
                  merchantInfo.data[0].business_street !== null
                    ? `${merchantInfo.data[0].business_street.toUpperCase()}, `
                    : ""
                } ${
                  merchantInfo.data[0].business_barangay !== null
                    ? `${merchantInfo.data[0].business_barangay.toUpperCase()}, `
                    : ""
                } ${
                  merchantInfo.data[0].business_city !== null
                    ? `${merchantInfo.data[0].business_city.toUpperCase()}, `
                    : ""
                } ${
                  merchantInfo.data[0].business_province !== null
                    ? merchantInfo.data[0].business_province.toUpperCase()
                    : ""
                }`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Contacts</p>
            </div>
            <div>
              <Tooltip title="Edit Contacts">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditContact(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Email"
                content={
                  merchantInfo.data[0].merchantinfouser.email !== null
                    ? merchantInfo.data[0].merchantinfouser.email
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Contact Number"
                content={
                  merchantInfo.data[0].reg_contact_no !== null
                    ? merchantInfo.data[0].reg_contact_no
                    : ""
                }
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Credentials</p>
            </div>
            <div>
              <Tooltip title="Edit Credentials">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditCredentials(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Username"
                content={merchantInfo.data[0].merchantinfouser.username}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <PasswordItem />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Location </p>
            </div>
            <div>
              <Tooltip title="Edit Location">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditLocation(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Status: "
                content={
                  merchantInfo.data[0].latitude !== null
                    ? "Has Location Added"
                    : "Location Not Yet Set"
                }
              />
            </Col>
          </Row>
        </>
      )}

      {editPersonal && (
        <EditPersonal
          open={editPersonal}
          close={() => setEditPersonal(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editBusiness && (
        <EditBusiness
          open={editBusiness}
          close={() => setEditBusiness(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editContact && (
        <EditContact
          open={editContact}
          close={() => setEditContact(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editCredentials && (
        <EditCredentials
          open={editCredentials}
          close={() => setEditCredentials(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editLocation && (
        <EditLocation
          open={editLocation}
          close={() => setEditLocation(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}
    </Drawer>
  );
};

export default AccountDetails;
